import React, { memo, useEffect, useRef, useState } from "react";
import { Handle, Position, NodeResizer } from "@xyflow/react";

const ChaSec = ({ id, data, selected }: any) => {
  const [icone, setIcone] = useState("fechado.png");

  return (
    <>
      <div
        className="resizable-node"
        style={{
          position: "relative",
          width: data.width || "50px",
          height: data.height || "50px",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "transparent",
        }}
      >
        {/* NodeResizer para tornar o nó redimensionável */}
        <NodeResizer
          color="#0077ff"
          isVisible={selected}
          minWidth={20}
          minHeight={20}
          keepAspectRatio={true}
          onResize={(event, size) => {
            data.width = `${size.width}px`;
            data.height = `${size.height}px`;
          }}
        />

        {/* Handles para conexões em todos os lados */}
        <Handle type="source" position={Position.Top} isConnectable id="top" />
        <Handle type="target" position={Position.Top} isConnectable id="top" />
        <Handle
          type="source"
          position={Position.Bottom}
          isConnectable
          id="bottom"
        />
        <Handle
          type="target"
          position={Position.Bottom}
          isConnectable
          id="bottom"
        />

        {/* Imagem redimensionável */}
        <img
          src={require(`../assets/${icone}`)}
          alt="Ícone"
          style={{
            width: "100%",
            height: "100%",
            pointerEvents: "none",
          }}
        />
      </div>
    </>
  );
};

export default memo(ChaSec);
